import { render, staticRenderFns } from "./liste-patients.html?vue&type=template&id=3e32b9e0&scoped=true&external"
import script from "./liste-patients.js?vue&type=script&lang=js&external"
export * from "./liste-patients.js?vue&type=script&lang=js&external"
import style0 from "./liste-patients.scss?vue&type=style&index=0&id=3e32b9e0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e32b9e0",
  null
  
)

export default component.exports